import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faLandmark } from '@fortawesome/free-solid-svg-icons'
import BaseModal from './BaseModal'
import bankImg from '../../assets/images/bank.png'

const AddBank = () => {
    return (
        <BaseModal modalId="modalAddBank" modalTitle="Add Bank" modalTitleIcon={faLandmark}>
            <form action="#" method="post" className="text-dark text-center">
                <img src={bankImg} alt="" className="rounded-circle w-50" />
                <div className="form-group">
                    <input type="text" className="form-control" placeholder="Unique Wallet Name" />
                </div>
                <div className="form-group">
                    <select name="" id="" className="form-control">
                        <option value="UBA">UBA</option>
                        <option value="GTB">GTB</option>
                    </select>
                </div>
                <button type="submit" className="btn btn-purple shadow-sm w-100 mt-4">Complete <FontAwesomeIcon icon={faCheckCircle} /></button>
            </form>  
        </BaseModal>
    )
}

export default AddBank